
<body>

    <div class="about-section">
    <h1>About Us</h1>
    <h3>Doctors a Touch Away</h3>
    </div>
    <br><br>
    
    <div class="container" id="about">
    <h1 style="color: #00ece9; text-align: center;">Doqma</h1> 
        <p><b style="color: #00ece9;">Doqma</b> is a product of Mavin Globus which helps patients to book appointments with doctors and know the information of the doctor for example his degree, his
    availabilty number of clinics he practices at. Moreover he can also receive his medical reports in this software he can also mention his medical conditions
    in his profile section overall doqma's aim to digitalise medical facilities provided in India.Doqma is a mobile-friendly software and also free of cost.
    By using Doqma we can also view our medical reports online. Doqma deals in all types of medical facilities including Dentists, Psychologists, Gynecologists,
    Cardiologists, Dermatologists, laboratories. Doqma gives the accurate information about the medical facilities provided by the particular doctor</p>
    </div>
    <br>
    <br>
    <div class="container">
    
    <div class="row">
    <!-- <div class="col-2">
    <img src="../../../assets/portfolio-img1.jpg" alt="..." class="img-thumbnail">
    </div> -->
    <div class="col-12">
    <h2 style="color:#00ece9;">OUR VISION</h2>
    <p>To digitalise medical facilities provided in India.Doqma is a mobile-friendly software and also free of cost. By using Doqma we can also view our medical reports online.</p>
    </div>
    </div>
    </div>
    <br>
    <br>
    
    <!-- <div class="container">
    
    <div class="row">
    <div class="col-12">
    <h2 style="color: rgb(96, 198, 230);">Core values</h2>
    <h5>The every partnership we entertain, each tactic we use and each decision we make is based on our core values. We always prefer client’s satisfaction, we believe in hard work, Our passion for our core purpose gives us courage to reach beyond our comfort zone to try innovative and unconventional ideas. We are admired and respected for our commitment to honesty, trust, and transparency.</h5>
    </div>
    <div class="col-2">
    <img src="../../../assets/portfolio-img2.jpg" alt="..." class="img-thumbnail">
    </div>
    </div>
    </div> -->
    
    
    </body>
    <app-footer></app-footer>
    
      <!-- End Footer -->
    
      <a href="#" id="myBtn" class="back-to-top" style="display: none;">
        <i class="bi bi-arrow-up"></i>
      </a>